import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { AdminAPI } from '@shared/types/api';

export interface AuditLogFilters {
  eventTimeId?: string;
  bookingId?: string;
  availableTableId?: string;
  subjectUserId?: string;
  actorUserId?: string;
  action?: string;
}

/**
 * Cursor-paginated admin audit log feed. Pass any subset of filters; the
 * server combines them with AND. Pages are returned newest-first.
 */
export function useAdminAuditLogs(filters: AuditLogFilters, enabled = true) {
  return useInfiniteQuery({
    queryKey: ['admin-audit-logs', filters],
    enabled,
    initialPageParam: undefined as string | undefined,
    queryFn: async ({ pageParam }): Promise<AdminAPI.GetAuditLogsResponse> => {
      const params = new URLSearchParams();
      if (filters.eventTimeId) params.set('eventTimeId', filters.eventTimeId);
      if (filters.bookingId) params.set('bookingId', filters.bookingId);
      if (filters.availableTableId) params.set('availableTableId', filters.availableTableId);
      if (filters.subjectUserId) params.set('subjectUserId', filters.subjectUserId);
      if (filters.actorUserId) params.set('actorUserId', filters.actorUserId);
      if (filters.action) params.set('action', filters.action);
      if (pageParam) params.set('before', pageParam);
      const qs = params.toString();
      return api.get(`/admin/audit-logs${qs ? `?${qs}` : ''}`);
    },
    getNextPageParam: (lastPage) => lastPage.data?.nextBefore ?? undefined,
  });
}
